import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import ClickableList from 'components/Shared/Layout/ClickableList';
import ExpandableSectionWithTitle from 'components/Shared/Layout/ExpandableSectionWithTitle';
import FeedItem from 'components/LeftMenu/UnicastFeeds/Item/container';
import PlaceholderLeftMenu from 'components/LeftMenu/Shared/Placeholder';
import ErrorFormatter from 'components/Shared/Errors/Formatter';
import ContentErrorComponent from 'components/Shared/Errors/ContentError';

import CatchError from 'components/CatchError';

import ItemLoadings from '../Shared/ItemLoadings';

const formatMessages = intl => () => ({
    placeholderTitle: intl.formatMessage({
        id: 'menuLeft.unicast.placeholder.title',
        defaultMessage: 'Vous n\'avez pas encore créé de discussion privée'
    }),
    expandUnicast: intl.formatMessage({
        id: 'menuLeft.feeds.link.expand.anchor',
        defaultMessage: 'Voir les autres discussions'
    }),
    title: intl.formatMessage({
        id: 'menuLeft.anchors.title',
        defaultMessage: 'Discussions privées'
    }),
    tooltipButtonPlus: intl.formatMessage({
        id: 'menuLeft.anchors.title.tooltip',
        defaultMessage: 'Créer une discussion privée'
    })
});

const UnicastFeeds = (props) => {
    const {
        deleteAnchor,
        isLoading = true,
        _feeds = [],
        _currentFeed,
        intl,
        openCreateUnicastFeed,
        error
    } = props;

    const renderItem = useCallback(id => (
        <FeedItem
            id={id}
            onRemove={deleteAnchor}
            _currentFeed={_currentFeed}
        />
    ), [deleteAnchor, _currentFeed]);

    let content = null;
    const i18n = formatMessages(intl)();

    if (isLoading) {
        content = () => <ItemLoadings repeat={6} />;
    } else if (!_feeds?.length && error) {
        content = () => (
            <ErrorFormatter
                error={error}
                render={ContentErrorComponent}
            />
        );
    } else if (_feeds && _feeds.length) {
        content = () => (
            <CatchError>
                <ClickableList items={_feeds} _current={_currentFeed}>
                    {renderItem}
                </ClickableList>
            </CatchError>
        );
    }

    const placeholder = (
        <PlaceholderLeftMenu
            title={i18n.placeholderTitle}
        />
    );

    return (
        <ExpandableSectionWithTitle
            onAdd={openCreateUnicastFeed}
            title={i18n.title}
            isLoading={isLoading}
            tooltip={i18n.tooltipButtonPlus}
            id="unicasts"
            placeholder={placeholder}
        >
            {content}
        </ExpandableSectionWithTitle>
    );
}

UnicastFeeds.propTypes = {
    deleteAnchor: PropTypes.func.isRequired,
    _currentFeed: PropTypes.string,
    error: PropTypes.object,
    intl: PropTypes.any.isRequired,
    openCreateUnicastFeed: PropTypes.func.isRequired,
    _feeds: PropTypes.array,
    isLoading: PropTypes.bool
};

export default injectIntl(UnicastFeeds);
